import React from "react";
import OwlCarousel from 'react-owl-carousel';
import VisibilitySensor from 'react-visibility-sensor';

export default class Carousel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            animated : false,
            animationClasses : ['carousel', 'owl-carousel-carousel'],
        };
        this.headerVisible = this.headerVisible.bind(this);
    }

    headerVisible(isVisible) {
        if (isVisible) {
            if (!this.state.animated) {
                var classes = this.state.animationClasses;
                classes.push('fadeInUp');
                classes.push('animated-fast');
                this.setState({ animated: true, animationClasses: classes });
            }
        }
    };
    render() {
        return(
            <VisibilitySensor partialVisibility={ true } onChange={ this.headerVisible }>
                <OwlCarousel 
                    className={ this.state.animationClasses.join(' ') }
                    items={3}
                    style={ { opacity : 0 } }
                    loop 
                    margin={20} 
                    nav
                    smartSpeed={800}  
                    responsive={ {
                            0:{
                                items:1
                            },
                            600:{
                                items:2
                            },
                            1000:{
                                items:3
                            }
                    } }      
                    navText={[
                        "<i class='ti-arrow-left owl-direction'></i>",
                        "<i class='ti-arrow-right owl-direction'></i>"
                    ]}
                >
                    {this.props.items.map (value => <div data={value} key={value.toString()}><img src={"images/"+value} alt="Romanian" /></div>)}
                </OwlCarousel>
            </VisibilitySensor>
        )
    }
} 


// WEBPACK FOOTER //
// ./src/components/carousel/owlCarousel.jsx